// @flow
import isImage from './isImage';
import is3dImage from './is3dImage';
import isWaveform from './isWaveform';
import isDocument from './isDocument';

// import sopClassDictionary from '../util/sopClassDictionary';

const getFirstSopClassUid = (instances: Array<Object>): string => {
  const sopClassUids = instances.map((instance) => instance.metadata.SOPClassUID);
  return sopClassUids[0];
};

export const imageIsSupported = (instances: Array<Object>): boolean => {
  if (instances.length === 0) return false;
  const SOPClassUID = getFirstSopClassUid(instances);

  return isImage(SOPClassUID);
};

export const image3dIsSupported = (instances: Array<Object>): boolean => {
  if (instances.length <= 3) return false;

  const SOPClassUID = getFirstSopClassUid(instances);
  return is3dImage(SOPClassUID);
};

export const image3dIsTilted = (instances: Array<Object>): boolean => instances.every((is) => is.metadata.GantryDetectorTilt > 0);

export const waveformIsSupported = (instances: Array<Object>): boolean => {
  if (instances.length === 0) return false;

  const SOPClassUID = getFirstSopClassUid(instances);
  return isWaveform(SOPClassUID);
};

export const documentIsSupported = (instances: Array<Object>): boolean => {
  if (instances.length === 0) return false;

  const SOPClassUID = getFirstSopClassUid(instances);
  return isDocument(SOPClassUID);
};

// checks if is multiframe
export const isMultiFrame = (instance) => {
  // SOPClassUID === sopClassDictionary.XRayAngiographicImageStorage
  return instance.metadata.NumberOfFrames && instance.metadata.NumberOfFrames > 1;
};
